const Services = () => {
  return (
    <div className="services" id="usluge">
      <div className="services-title">Usluge</div>
      <div className="services-images">
        <div className="service-image">
          <div className="service-centar">
            <div className="img-div">
              <img src="images/usluga1.jpg" alt="triotim" />
            </div>
            <div className="service-title">Plan zaštite od udesa</div>
          </div>
          <div className="service-subtitle">
            Plan zaštite od udesa izrađuje se u skladu s važećim Zakonom o
            smanjenju rizika od katastrofa i upravljanju vanrednim situacijama
            (Sl. Glasnik RS br. 87/2018), Pravilnikom o vrstama i količinama
            opasnih materija, objektima i drugim kriterijumima.
          </div>
          <div className="service-button">
            <a href="/plan-zastite-od-udesa">Više</a>
          </div>
        </div>

        <div className="service-image">
          <div className="service-centar">
            <div className="img-div">
              <img src="images/usluga2.jpg" alt="triotim" />
            </div>
            <div className="service-title">Procena rizika</div>
          </div>
          <div className="service-subtitle">
            Procena rizika od katastrofa je najvažniji strateški dokument kojim
            se identifikuju opasnosti, određuje nivo rizika i na osnovu toga
            predlažu mere za ublažavanje, kako bi se uticaj na život i zdravlje
            ljudi, materijalna i kulturna dobra i životnu sredinu sveo na
            minimum.
          </div>
          <div className="service-button">
            <a href="/procena-rizika-od-katastrofa">Više</a>
          </div>
        </div>

        <div className="service-image">
          <div className="service-centar">
            <div className="img-div">
              <img src="images/usluga3.jpg" alt="triotim" />
            </div>
            <div className="service-title">Plan zaštite i spasavanja</div>
          </div>
          <div className="service-subtitle">
            Planom zaštite i spasavanja se planiraju mere i aktivnosti za
            sprečavanje i umanjenje posledica katastrofa, snage i sredstva
            subjekata sistema smanjenja rizika od katastrofa i upravljanje
            vanrednim situacijama.
          </div>
          <div className="service-button">
            <a href="/plan-zastite-i-spasavanja">Više</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
